import APIVariables from "../../../../services/api-variables";
import Axios from "../../../../services/Axios";
import { handleCatch } from "../../../../shared/helpers";

export async function printPatientInitiationPaf(resId) {
  return Axios.get(APIVariables.DOWNLOAD_PAF + resId)
    .then((response) => response.data.report)
    .then(async function (base64) {
      const base64Pdf = await fetch(`data:application/pdf;base64,${base64}`);
      return base64Pdf.blob();
    })
    .then((blob) => {
      const file = new Blob([blob], {
        type: "application/pdf",
      });
      const fileURL = URL.createObjectURL(file);
      const downloadLink = document.createElement("a");
      downloadLink.href = fileURL;
      downloadLink.download = `PAF.pdf`;
      downloadLink.click();
      downloadLink.remove();
      URL.revokeObjectURL(downloadLink.href);
    })
    .catch((error) => {
      handleCatch(error);
    });
}
